import React from "react";
import * as Text from "@/components/text";
import breakpoints from "@/constants/breakpoinst";
import useWindowSize from "@/hooks/useWindowSize";
import Button from "../actions/Button";
import { CheckIcon } from "@heroicons/react/outline";
import Image from "next/legacy/image";

export default function CallToAction() {
  const windowSize = useWindowSize();
  return (
    <div className="flex flex-col justify-center">
      {/* <div className=" flex bg-black sm:flex-col md:flex-row md:justify-between ">
        <div className="flex flex-col sm:mx-4 sm:pt-10 sm:pb-6 md:mx-8 md:max-w-[314px] md:py-10 lg:max-w-[500px] ">
          <Text.Display
            fontWeight="extrabold"
            size={windowSize.width < breakpoints.lg ? "sm" : "md"}
            className="text-white"
          >
            Apóyanos
          </Text.Display>
          <Text.Body
            size={windowSize.width < 720 ? "sm" : "md"}
            className="font-extralight text-white sm:mt-4 md:mt-5 lg:text-lg"
          >
            ¡Súmate a nuestros aliados y ayúdanos a movilizar espacios de
            encuentro y acción colectiva para construir otros mundos a través
            del documental.
          </Text.Body>
        </div>
        <div className="max-w-[500px] pb-10 sm:mx-4 md:w-full md:py-9 md:px-8 lg:pt-14">
          <Button
            color="primary-dark"
            size="lg"
            className="w-full"
            leadingIcon={
              <Image
                alt="donate"
                height={20}
                width={20}
                src="/next_assets/icons/donate_collective.svg"
              />
            }
            label="Donar con Open Collective"
          ></Button>
          <Button
            color="primary-dark"
            size="lg"
            className="mt-4 w-full"
            leadingIcon={
              <Image
                alt="donate"
                height={20}
                width={20}
                src="/next_assets/icons/paypal.svg"
              />
            }
            label="Donar con PayPal"
          ></Button>
        </div>
      </div> */}
      <div className="flex border-[1px] border-black sm:flex-col md:flex-row md:justify-between ">
        <div className="flex flex-col sm:mx-4 sm:pb-6 sm:pt-10 md:mx-8 md:max-w-[314px] md:py-10 lg:max-w-[500px]">
          <Text.Display
            fontWeight="light"
            size={windowSize.width < breakpoints.lg ? "sm" : "sm"}
          >
            Suscríbete al newsletter
          </Text.Display>
          <Text.Body
            size="lg"
            className="font-extralight text-gray-500 sm:mt-4 sm:w-[300px] md:mt-5 md:w-[330px] lg:text-lg"
          >
            Mantente al día con las últimas noticias, eventos, proyecciones y
            más.
          </Text.Body>
        </div>
        <div className="max-w-[500px] pb-10 sm:mx-4 md:w-full md:px-8 md:py-9">
          <form
            action="https://ambulante.us16.list-manage.com/subscribe/post?u=83db27a5962ce56c73cedeb90&amp;id=c39fe7c593&amp;f_id=00dec2e1f0"
            method="post"
            id="mc-embedded-subscribe-form"
            name="mc-embedded-subscribe-form"
            target="_blank"
          >
            <div className="pb-3">
              <Text.Label
                size="lg"
                className="font-bold sm:mt-4 sm:w-[300px] md:mt-5 lg:text-lg"
              >
                Ingresa tu dirección de email
              </Text.Label>
            </div>
            <input
              type="email"
              name="EMAIL"
              id="mce-EMAIL"
              className="h-11 w-full border-2 px-3"
              required
              placeholder="ej. tunombre@tucorreo.com"
            ></input>
            <Button
              type="submit"
              color="secondary-light"
              size="lg"
              className="mt-4 w-full"
              trailingIcon={<CheckIcon />}
              label="Suscribir"
            ></Button>
          </form>
        </div>
      </div>
    </div>
  );
}
